import { useTranslation } from 'next-i18next'

import { Link } from '~/components'
import { Menu } from '~/donation/types/menu.types'

function DropdownItem({ menu }: { menu: Menu }): React.ReactElement {
  const { t } = useTranslation('donation')

  return (
    <li className="text-xxs tracking-widest font-bold text-blue-strong">
      <Link className="py-1 px-2" key={menu.titleKey} to={menu.path}>
        {t(`menu.${menu.titleKey}`)}
      </Link>
    </li>
  )
}

export default DropdownItem
